/** Minimal repository shape the switcher needs to render and return a selection. */
export interface OrgRepositoryPickerRepository {
  id: string
  name: string
  nameWithOwner: string
  ownerLogin: string
  isPrivate: boolean
}

export function repositoryItemKey(repo: OrgRepositoryPickerRepository): string {
  return `repo:${repo.id}`
}
